




























































































































































































import "@/assets/sass/encoding/encoding.scss";
import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { Trans } from "@/shared/scripts/helpers/translation/translation";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";
import iwTransactionType from "@/optimizedEncoding/components/BasicInfo/TransactionType.vue";
import iwCardList from "@/shared/components/cardList/CardList.vue";
import iwEstimationToolBanner from "@/shared/components/EstimationToolBanner.vue";
import { getPricing } from "@/shared/scripts/PricingApi";
import { MyClassifiedsStoreState } from "@/shared/interfaces/MyClassifieds.interface";
import iwPricingPack from "@/optimizedEncoding/components/packSelection/PackPricing.vue";
import iwResultsGuaranteeNotice from "@/shared/components/pricing/ResultsGuaranteeNotice.vue";
import iwPackInfoModal from "@/shared/components/pricing/PackInfoModal.vue";
import { OptimizedPack } from "@/shared/interfaces/optimizedEncoding/PackSelection.interface";
import { configurePacksOnWelcomePageInit } from "@/optimizedEncoding/scripts/packConfig";
import { isEmpty } from "lodash";
import "@/assets/sass/optimizedEncoding/optimizedEncoding.scss";
import { normalizePropertyType } from "./scripts/helpers/property";
import iwPropertyCard from "@/optimizedEncoding/components/BasicInfo/PropertyCard.vue";
import iwProBanner from "@/optimizedEncoding/components/ProBanner.vue";
import iwDeliveryNoticeBanner from "@/optimizedEncoding/components/DeliveryNoticeBanner.vue";
import { isFeatureEnabled } from "@/shared/scripts/helpers/featureFlags";

const DEFAULT_PRICES = {
    FOR_RENT: 500,
    FOR_SALE: 2501
};

const DEFAULT_PROPERTY_TYPE = "APARTMENT";

export default Vue.extend({

    components: {
        iwResultsGuaranteeNotice: iwResultsGuaranteeNotice,
        iwTransactionType: iwTransactionType,
        iwCardList: iwCardList,
        iwEstimationToolBanner: iwEstimationToolBanner,
        iwPricingPack: iwPricingPack,
        iwPackInfoModal: iwPackInfoModal,
        iwPropertyCard: iwPropertyCard,
        iwProBanner: iwProBanner,
        iwDeliveryNoticeBanner: iwDeliveryNoticeBanner,
    },

    props: {
        action: {
            type: String,
            default: null,
            required: false
        }
    },
    data: function() {
        return {
            isMobile: true,
            pathInStore: "transaction.pricing",
            selectedPackageInStore: "publication.visualizationOption",
            monthlyrentalStore: "transaction.rental.monthlyRentalPrice",
            configuredPacksInStore: "transaction.configuredPacks",
            sellPrice: "transaction.sale.price",
            packsLoaded: false,
            showErrorPricesMessage:false,
            watchEnabled: false,
            packInfoType: null as string | null,
            isKotEnabled: isFeatureEnabled("kot"),
        };
    },

    computed: {
        ...mapState("UserModule", ["user"]),
        ...mapGetters({
            drafts: "MyClassifiedsModule/draftsAndPublishable",
            propertyType: "FormModule/getPropertyType",
            isLogged: "UserModule/isLogged",
            isMasquerading: "UserModule/isMasquerading",
            getValue: "FormModule/getValue",
        }),
        ...mapState("MyClassifiedsModule", {
            classified: state => (state as MyClassifiedsStoreState).myClassifiedSelected
        }),
        transactionType: function(): string {
            return this.getValue("transaction.type");
        },
        propertySubtype: function(): string {
            return this.getValue("property.subtype") || "";
        },
        selectedType: function(): string {
            if (this.propertyType === "APARTMENT" && this.propertySubtype === "KOT") {
                return "KOT";
            }
            return normalizePropertyType(this.propertyType);
        },
        packs: function(): Array<OptimizedPack> {
            if (this.packsLoaded) {
                return this.$store.getters["FormModule/getValueTransaction"](this.configuredPacksInStore);
            }
            return [];
        },
        seeAllUrl: function(): string {
            switch(Trans.currentLocale) {
            case "fr":
                return `./classifieds#/${Trans.currentLocale}/mes-annonces`;
            case "nl":
                return `./classifieds#/${Trans.currentLocale}/mijn-zoekertjes`;
            default:
                return `./classifieds#/${Trans.currentLocale}/my-classifieds`;
            }
        },
        cmsUrl: function(): string {
            switch(Trans.currentLocale) {
            case "fr":
                return "https://www.immoweb.be/fr/page/publier-mon-annonce";
            case "nl":
                return "https://www.immoweb.be/nl/page/mijn-zoekertje-plaatsen";
            default:
                return "https://www.immoweb.be/en/page/publish-my-classified";
            }
        },
        proUrl: function(): string {
            return process.env.VUE_APP_PRO + "/" + Trans.currentLocale;
        },
        propertyTypes: function (): Array<{ label: string; value: string; icon: string; }> {
            const tiles: Array<{ label: string; value: string; icon: string; }> = [
                {
                    label: this.$t("house") as string,
                    value: "HOUSE",
                    icon: "images/property/icon-house.svg"
                },
                {
                    label: this.$t("apartment") as string,
                    value: "APARTMENT",
                    icon: "images/property/icon-apartment.svg"
                },
            ];
            if (this.isKotEnabled) {
                tiles.push({
                    label: this.$t("kot") as string,
                    value: "KOT",
                    icon: "images/property/icon-student-room.svg"
                });
            }
            tiles.push({
                label: this.$t("other") as string,
                value: "OTHER",
                icon: "images/property/icon-other.svg"
            });
            return tiles;
        },
        optimizedEncodingUrl: function(): string {
            return this.$t("route-optimized-encoding") as string;
        }
    },

    watch: {
        isLogged: function(nowLogged) {
            if (!this.drafts && nowLogged) {
                this.fetchClassifieds();
            }
        },
        transactionType: function(newVal) {
            if (this.watchEnabled && newVal) {

                this.initializeTransactionFlow(newVal);
            }
        },
    },

    mounted: function() {
        type TransactionTypeComponent = Vue & {
            updateTransactionType?: (val: string) => void;
        };
        this.$nextTick(() => {
            (this.$refs.transactionTypeComponent as TransactionTypeComponent)?.updateTransactionType?.(this.transactionType);
        });

        if (this.isLogged) {
            this.fetchClassifieds();
        }

        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });
        pushPageViewEvent("classified_deposit_landing");

        if(this.$store.getters["FormModule/getIsEditionMode"]) {
            this.$store.dispatch("FormModule/setIsEditionMode", false);
        }
    },

    created: async function () {
        await this.$store.dispatch("FormModule/resetCriteria");
        this.$store.commit("CustomersModule/resetCustomer");
        this.$store.commit("PicturesModule/setPictures", []);

        await this.selectPropertyType(DEFAULT_PROPERTY_TYPE);

        if (this.transactionType) {
            await this.initializeTransactionFlow(this.transactionType);
        } else {
            this.packsLoaded = false;
        }

        this.watchEnabled = true; // Enable watcher after init
    },

    methods: {
        ...mapActions({
            selectPropertyType: "FormModule/setPropertyType",
            fetchClassifieds: "MyClassifiedsModule/fetchClassifieds",
            initValidatedStep: "StepsWizard/validate",
        }),
        handlePropertyTypeClick: function(tileId: string) {
            const isKot: boolean = tileId === "KOT";
            const propertyType: string = isKot ? "APARTMENT" : tileId;
            const propertySubtype: string = isKot ? "KOT" : tileId;
            this.selectPropertyType(propertyType);
            this.$store.dispatch("FormModule/addValue", { path: "property.subtype", value: propertySubtype });
        },
        getPacks: async function(): Promise<Array<OptimizedPack>|null> {
            return await getPricing({
                classified: isEmpty(this.classified) ? null : this.classified,
                type: "PUBLICATION",
                preferShortestRentDuration: true,
            }).then(() =>  {
                const storedPacks = this.$store.getters["FormModule/getValueTransaction"](this.pathInStore);
                
                if (storedPacks) {
                    const configuredPacks = configurePacksOnWelcomePageInit(storedPacks, this.getTransactionType());
                    
                    this.$store.commit("FormModule/addValueUI", { "path": "shouldReloadPacks", "value": false });
                    this.$store.commit("FormModule/addValueTransaction", {"path": this.configuredPacksInStore, "value": configuredPacks});
                    this.packsLoaded = true;
                    return this.packs;
                }
                return null;
            })
                .catch(error => {
                    console.error(error);
                    return null;
                });
        },
        initializeTransactionFlow: async function(transactionType: string) {
            await this.$store.dispatch("FormModule/addValue", {
                path: this.pathInStore,
                value: transactionType,
            });

            const pricePath = transactionType === "FOR_RENT" ? this.monthlyrentalStore : this.sellPrice;
            const priceValue = DEFAULT_PRICES[transactionType as "FOR_RENT" | "FOR_SALE"];

            await this.$store.dispatch("FormModule/addValue", {
                path: pricePath,
                value: priceValue,
            });

            const packs = await this.getPacks();
            this.packsLoaded = !!packs;
        },
        start: async function() {
            await this.$store.dispatch("FormModule/resetCriteria");
            this.$router.push(this.optimizedEncodingUrl);
        },
        resumeDrafts: function(): void {
            const draftsList = this.$refs.draftsList as Vue | undefined;
            draftsList?.$el?.scrollIntoView({ behavior: "smooth", block: "start" });
        },
        openPackInfoModal: function(packType: string) {
            this.packInfoType = packType;
        },
        closePackInfoModal: function() {
            this.packInfoType = null;
        },
        editClassified: function(id: string) {
            if(this.$store.getters["MyClassifiedsModule/getClassifiedById"](id)) {
                let urlTranslated = this.$t("step-property-type") as string;
                const to = this.$router.resolve({path: urlTranslated + id });
                this.$router.push(to.location);
            }
        },
    }
});
